import { CALL_TIMER_INTERVAL_MS } from 'Modules/softphone/hooks/useCallTimer/index.constants';
import { useEffect, useState } from 'react';

/**
 * Hook that calculates elapsed seconds from a given ISO start time.
 * Updates every second while `active` is true.
 *
 * @param startTime - ISO 8601 timestamp of when the conference started
 * @param active - Whether the timer should be running
 * @returns Duration in seconds
 */
export function useConferenceTimer(
  startTime: string | null | undefined,
  active: boolean
): number {
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!active || !startTime) {
      setDuration(0);
      return;
    }

    const calculateDuration = () => {
      const start = new Date(startTime).getTime();
      const now = Date.now();
      return Math.floor((now - start) / CALL_TIMER_INTERVAL_MS);
    };

    setDuration(calculateDuration());

    const intervalId = setInterval(() => {
      setDuration(calculateDuration());
    }, CALL_TIMER_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, [active, startTime]);

  return duration;
}
